import { useNavigate } from "react-router-dom";
import ROUTERS from '../../../../commons/constans/router';
import { ReactComponent as IconNextBtnW } from '../../../../assets/images/icon_next_btn_w.svg';

type props = {};

const BtnGoToAwardRegister = ({show = true}: props) => {
  const navigate = useNavigate();

  const goToAwardRegister = () => {
    navigate(ROUTERS.AWARD_REGISTER)
  }

  if (!show) {
    return null
  }

  return (
    <button
      className="btn btn-rounded btn-primary btn-purple"
      onClick={goToAwardRegister}>
      <label>참여 등록하기</label>
      <IconNextBtnW />
    </button>
  );
};

export default BtnGoToAwardRegister;
